import { Popconfirm, Switch, Tooltip } from 'antd'
import { Button, Typography } from 'modules/core/components'
import { EditOutlined, DeleteOutlined } from '@ant-design/icons'
import numeral from 'numeral'

export const FILTERABLE_COLUMN_TO_PARAM = {
  document_type: 'document_type_id',
  area: 'area_id',
  purchase_group: 'purchase_group_id',
  society: 'society_id',
}

const renderData = (value, rule, onToggle, isSaving) => {
  return {
    min_amount: '$' + numeral(parseInt(value)).format('0,0.00'),
    max_amount: '$' + numeral(parseInt(value)).format('0,0.00'),
    is_active: (
      <Switch
        loading={isSaving}
        size="small"
        checked={rule.is_active}
        onChange={() => onToggle(rule.id, rule.is_active)}
      />
    ),
    area: value?.name || null,
    purchase_group: value?.name || null,
    society: value?.name || null,
    name: renderWithEllipsis(value, 30),
    description: renderWithEllipsis(value, 30),
  }
}

const renderWithEllipsis = (text, limit = 30) => {
  if (!text) return '-'

  const isLong = text.length > limit
  const displayText = isLong ? `${text.slice(0, limit)}...` : text

  return isLong ? (
    <Tooltip title={text}>
      <span>{displayText}</span>
    </Tooltip>
  ) : (
    <span>{text}</span>
  )
}

const buildFilterOptionsForColumn = (columnKey, filterOptions) => {
  switch (columnKey) {
    case 'document_type':
      return (filterOptions.documentTypes || []).map((dt) => ({ text: dt.name, value: dt.id }))
    case 'area':
      return (filterOptions.areas || []).map((a) => ({ text: a.name, value: a.id }))
    case 'purchase_group':
      return (filterOptions.purchaseGroups || []).map((g) => ({
        text: g.name_destination || g.name,
        value: g.id,
      }))
    case 'society':
      return (filterOptions.societies || []).map((s) => ({
        text: s.name_destination || s.name,
        value: s.id,
      }))
    default:
      return []
  }
}

const buildColumns = ({
  t,
  columns,
  onToggle,
  onClickEdit,
  setDeleteId,
  deleteId,
  onConfirmDelete,
  isSaving,
  filters = {},
  filterOptions = {},
}) => {
  return [
    ...columns
      .filter((el) => el.key !== 'id')
      .map((col) => {
        const paramKey = FILTERABLE_COLUMN_TO_PARAM[col.key]
        const filterProps = paramKey
          ? {
              filters: buildFilterOptionsForColumn(col.key, filterOptions),
              filterMultiple: false,
              filteredValue: filters[paramKey] ? [filters[paramKey]] : null,
              onFilter: () => true,
            }
          : {}
        return {
          ...col,
          ...filterProps,
          width: 100,
          render: (value, rule) => renderData(value, rule, onToggle, isSaving)[col.key] ?? value,
        }
      }),
    {
      key: 'actions',
      dataIndex: 'id',
      title: t('FIELD_ACTIONS'),
      align: 'right',
      width: 80,
      fixed: 'right',
      render: (id, rule) => {
        return (
          <>
            <Button.Icon
              title="ACTION_EDIT"
              icon={<Typography.Icon level={2} icon={EditOutlined} />}
              onClick={() => onClickEdit(rule)}
            />
            <Popconfirm
              placement="bottomRight"
              title={t('CONFIG_APPROVALS_DELETE_STRATEGY_POPCONFIRM_TEXT')}
              okText={t('ACTION_DELETE')}
              onConfirm={onConfirmDelete}
              okButtonProps={{ loading: isSaving }}
              cancelButtonProps={{ disabled: isSaving }}
              cancelText={t('ACTION_CANCEL')}
              onCancel={() => setDeleteId(null)}
              visible={rule.id === deleteId}
            >
              <Button.Icon
                title="ACTION_DELETE"
                icon={<Typography.Icon level={2} icon={DeleteOutlined} />}
                onClick={() => setDeleteId(rule.id)}
              />
            </Popconfirm>
          </>
        )
      },
    },
  ]
}

export default buildColumns
